import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "body"]
  static values = { url: String }

  open() {
    if (!this.hasDialogTarget) return

    this.bodyTarget.innerHTML = this.spinnerHTML
    this.dialogTarget.showModal()
    this.loadPreview()
  }

  close() {
    if (!this.hasDialogTarget) return

    this.dialogTarget.close()
    this.bodyTarget.innerHTML = ""
  }

  loadPreview() {
    fetch(this.urlValue, {
      headers: { "Accept": "text/html" }
    })
      .then(response => response.text())
      .then(html => {
        this.bodyTarget.innerHTML = html
      })
  }

  get spinnerHTML() {
    return `<div class="flex items-center justify-center h-24">
      <svg class="animate-spin h-6 w-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
      </svg>
    </div>`
  }
}
